import store from 'utils/store/withMiddleware'
import forEach from 'utils/DOM/forEach'

function handleClickOptionCard() {
  const value = this.dataset.id
  let exist = false
  const filters = store.getState().filters
  const type = filters.type.filter(item => {
    const keepItem = item != value

    if (!keepItem) {
      exist = true
    }

    return keepItem
  })

  if (!exist) {
    type.push(value)
  }

  forEach('[name="type"]', node => {
    node.checked = type.includes(node.value)
  })

  filters.type = type
  store.update({
    filters
  })
}

export default handleClickOptionCard
